module.exports = __webpack_public_path__ + "img/cafe_international-lg.ff2680a8.jpg";